module.exports = ".lui-card__seed{border-radius:2px;border:1px var(--lui-background-color) solid;padding:var(--lui-padding);background:var(--lui-background-color);box-shadow:0 2px 8px 0 var(--lui-shadow-color);overflow:auto}.lui-card__seed:hover{box-sizing:border-box;border:1px var(--lui-field-border-color) solid}.lui-card-vertical{height:440px;width:328px}.lui-card-horizontal{height:144px;width:1032px}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-card/theme/lui-card.scss
// module id = 374
// module chunks = 0 1 36